export default {
  DesktopHeaderControl__CARDMEMBER: "Cardmember",
  DesktopHeaderControl__CREATE_ACCOUNT: "Create account",
  DesktopHeaderControl__CREDIT_CARD__EMPLOYEE: "Rapid Rewards Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__LEGACY_CHASE: "Rapid Rewards Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__LEGACY_CLASSIC: "Rapid Rewards Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__LEGACY_CLASSIC_CARD: "Rapid Rewards Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__LEGACY_PLUS: "Rapid Rewards Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PERFORMANCE: "Performance Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PERFORMANCE_BUSINESS: "Performance Business Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PLUS: "Plus Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PLUS_BUSINESS: "Plus Business Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PREMIER: "Premier Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PREMIER_BUSINESS: "Premier Business Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PRIORITY: "Priority Credit Cardmember",
  DesktopHeaderControl__CREDIT_CARD__PRIORITY_BUSINESS: "Priority Business Credit Cardmember",
  DesktopHeaderControl__GREETING: (option) => `Hi, ${option.name}`,
  DesktopHeaderControl__LOG_IN: "Log in",
  DesktopHeaderControl__LOG_OUT: "Log out",
  DesktopHeaderControl__MY_ACCOUNT: "My Account",
  DesktopHeaderControl__POINTS: " points",
  DesktopHeaderControl__TIER_A_LIST: "A-List",
  DesktopHeaderControl__TIER_A_LIST_PREFERRED: "A-List Preferred",
  DesktopHeaderControl__TIER_PENDING: "Status Pending",
  DesktopHeaderControl__TRAVELER_ACCOUNT: "Traveler Account",
};
